import { useGetCompanyById } from 'queries/company';
import { useParams } from 'react-router-dom';

export const useCompanyFromUrl = () => {
  const { accountId: accountIdParam } = useParams();
  const accountId = parseInt(accountIdParam ?? '-1', 10);

  return useGetCompanyById(accountId);
};
